const { REACT_APP_MOVCAD_LEGACY } = process.env;

export const legacyRoutes = {
  Home: {
    url: `${REACT_APP_MOVCAD_LEGACY}/Home.aspx`,
    name: 'Home',
  },
  ConsultaLista: {
    url: `${REACT_APP_MOVCAD_LEGACY}/ConsultaLista.aspx`,
    name: 'Lista',
  },
  Segundavia: {
    url: `${REACT_APP_MOVCAD_LEGACY}/ConsultaSolicitacao.aspx`,
    name: 'Lista',
  },
  ConsultaBeneficiarios: {
    url: `${REACT_APP_MOVCAD_LEGACY}/PesquisaBeneficiario.aspx`,
    name: 'Lista',
  },
  CadastrarLista: {
    url: `${REACT_APP_MOVCAD_LEGACY}/CadastrarLista.aspx`,
    name: 'Lista',
  },
  CadastrarListaTitularUSP: {
    url: `${REACT_APP_MOVCAD_LEGACY}/CadastrarLista.aspx?isRedirectUsp=1`,
    name: 'Lista',
  },
  CadastrarListaDependenteUSP: {
    url: `${REACT_APP_MOVCAD_LEGACY}/CadastrarLista.aspx?isRedirectUsp=2`,
    name: 'Lista',
  },
  ConfiguracaoLogin: {
    url: `${REACT_APP_MOVCAD_LEGACY}/ConfiguracaoLogin`,
    name: 'Lista',
  },
};
